import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import { ArrowRight, Compass, Heart, Sparkles } from "lucide-react";
import Hummingbird from "../components/brand/Hummingbird";

const StartHere = () => {
  const { t } = useLang();
  return (
    <div className="pt-28 min-h-screen" data-testid="starthere-page">
      {/* ─── HERO ─────────────────────────────────────────────────── */}
      <section className="container-sat pt-10 lg:pt-16 pb-12 lg:pb-20">
        <div className="grid lg:grid-cols-[1.1fr_1fr] gap-12 lg:gap-20 items-start">
          {/* Left column: title + intro */}
          <div className="max-w-2xl">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-12 h-px bg-[#D4AF37]"></span>
              <span className="overline">{t("starthere.overline")}</span>
            </div>
            <h1 className="headline-xl text-5xl md:text-7xl lg:text-[5.6rem] xl:text-[6.4rem]">
              {t("starthere.title")}
            </h1>
            <p className="serif italic text-xl md:text-2xl text-white/65 mt-8 max-w-xl">
              {t("starthere.subtitle")}
            </p>

            <div className="mt-12 flex items-center gap-4 text-xs tracking-[0.3em] uppercase text-white/45">
              <Sparkles size={14} className="text-[#D4AF37]" />
              <span>Zwei Wege, die dich tiefer hineinführen</span>
            </div>
          </div>

          {/* Right column: stacked CTA cards */}
          <div className="space-y-5">
            <Link
              to="/quiz"
              className="card-lift group relative block rounded-3xl overflow-hidden border border-white/8 p-8 lg:p-10 bg-gradient-to-br from-[#0E1A30] to-[#050B1B] min-h-[280px] flex flex-col justify-between"
              data-testid="starthere-card-quiz"
            >
              <div className="absolute -bottom-10 -right-10 opacity-25 group-hover:opacity-45 transition pointer-events-none">
                <Hummingbird size={200} />
              </div>
              <div className="relative">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#D4AF37]/10 text-[#D4AF37] text-[10px] tracking-widest uppercase">
                  <Compass size={12} /> SAT-Test
                </div>
                <h2 className="serif text-3xl lg:text-4xl mt-5 leading-tight">
                  Welche Spielregel des Lebens fehlt dir aktuell?
                </h2>
              </div>
              <div className="relative text-white/55 mt-5 flex items-center gap-2 text-sm">
                12 Fragen · 3 Minuten
                <ArrowRight size={16} className="group-hover:translate-x-1 transition" />
              </div>
            </Link>

            <Link
              to="/lebensrad"
              className="card-lift group relative block rounded-3xl overflow-hidden border border-white/8 p-8 lg:p-10 bg-gradient-to-br from-[#0E1A30] to-[#050B1B] min-h-[280px] flex flex-col justify-between"
              data-testid="starthere-card-wheel"
            >
              <div className="relative">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#4B2E83]/15 text-[#a48cff] text-[10px] tracking-widest uppercase">
                  <Heart size={12} /> Lebensrad
                </div>
                <h2 className="serif text-3xl lg:text-4xl mt-5 leading-tight">
                  Wie rund läuft dein Leben gerade — wirklich?
                </h2>
              </div>
              <div className="relative text-white/55 mt-5 flex items-center gap-2 text-sm">
                8 Bereiche · 2 Minuten
                <ArrowRight size={16} className="group-hover:translate-x-1 transition" />
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* ─── CLOSING WORD ─────────────────────────────────────────── */}
      <section className="container-sat pb-32 lg:pb-40">
        <div className="glass rounded-3xl p-10 lg:p-16 text-center max-w-4xl mx-auto">
          <p className="serif italic text-2xl md:text-3xl lg:text-4xl text-white/85 max-w-3xl mx-auto leading-snug">
            „Manchmal zeigt sich der Weg erst, wenn man anfängt, ihn zu gehen.&ldquo;
          </p>
          <Link to="/#kontakt" className="btn-secondary mt-10 inline-flex">
            {t("nav.cta")} <ArrowRight size={16} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default StartHere;
